import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useChatInput } from '../hooks/use-chat-input';
import { ChatView } from './chat';
import { RudderstackTracker } from '../../../../infra/observability/rudderstack/rudderstack';
import { REPORTING_BOT_QUERY_INTERRUPTED } from '../../../../infra/observability/rudderstack/events';
export var ChatContainer = function (_a) {
    var chat = _a.chat, onSuggestionClick = _a.onSuggestionClick, onMessageSubmit = _a.onMessageSubmit;
    var _b = useChatInput({ onMessageSubmit: onMessageSubmit }), inputValue = _b.inputValue, handleInputChange = _b.handleInputChange, handleSubmit = _b.handleSubmit, handleKeyDown = _b.handleKeyDown;
    var endOfChatRef = useRef(null);
    useEffect(function () {
        if (endOfChatRef.current) {
            endOfChatRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [chat.messages]);
    useEffect(function () {
        return function () {
            if (chat.isResponding) {
                RudderstackTracker.getInstance().track(REPORTING_BOT_QUERY_INTERRUPTED);
            }
        };
    }, []);
    return (_jsx(ChatView, { inputValue: inputValue, handleInputChange: handleInputChange, handleSubmit: handleSubmit, handleKeyDown: handleKeyDown, onSuggestionClick: onSuggestionClick, chat: chat, ref: endOfChatRef }));
};
